const LinkButton = (props) => {
  return (
    <button className="text-secondary mx-3 bg-white border-0" {...props}>
      {props.children}
    </button>
  );
};

export default LinkButton;
